/**
 * Created by rathompson on 1/28/22
 * File: Addons
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { useMemo } from 'react'
import styled from 'styled-components'
import _ from 'lodash'
import { Body } from '@panwds/react-ui'
import { DO_NOT_DISPLAY_ADDONS } from '../../../../../common/constants/LabelConstants'

import { ARRAY } from '../../../../../common/utils/Utils'
import Addon from './Addon'
import BundleAddon from './BundleAddon'

const ADDONS = styled.div`
  input[type="checkbox"] {
    color: #B8B8B8;
  }

  div.tw-font-lato.tw-text-xs.tw-space-y-1 {
    width: min-content;
  }
`

const Addons = (props) => {
  // console.log(props)
  const { cspDropDownData, license, loading, domainPostFix, apps, selectedTSGInstances, selectedTreeNode } = props
  const addons = useMemo(() => {
    const addonEntitlements = license?.entitlements?.filter(item => item?.asset_type === 'addon' && !DO_NOT_DISPLAY_ADDONS.has(item.app_id))
    if (!ARRAY?.hasArray(addonEntitlements)) {
      return <Body>None</Body>
    }
    // need to dedup same addons, like saas
    return license?.entitlements?.reduce((accumulator, currentValue) => {
      const existingObject = accumulator.find(obj => obj.app_id === currentValue.app_id)
      if (!existingObject) {
        accumulator.push(currentValue)
      }
      return accumulator
    }, []).filter(item => item?.asset_type === 'addon' && !DO_NOT_DISPLAY_ADDONS.has(item.app_id) && !item.bundle_app_id && !item.bundle_display_name)?.map((addon, index) => {
      return <Addon key={index} {...{ addon, domainPostFix, cspDropDownData, loading, selectedTSGInstances, apps, selectedTreeNode }} />
    })
  }, [license?.entitlements, domainPostFix, cspDropDownData, loading, selectedTSGInstances, apps, selectedTreeNode])

  const bundleAddons = useMemo(() => {
    const hasBundle = license?.entitlements.some(each => each.bundle_app_id && each.bundle_display_name)
    if (!hasBundle) {
      return undefined
    }
    const bundleAddons = _.groupBy(license?.entitlements.filter(each => each.bundle_app_id && each.bundle_display_name), 'bundle_app_id')
    return Object.values(bundleAddons).map((eachBundle, index) => {
      const bundleDisplayName = eachBundle[0].bundle_display_name

      return (
        <BundleAddon key={index}
          {...{
            bundleDisplayName,
            bundle: eachBundle,
            domainPostFix,
            cspDropDownData,
            loading,
            selectedTSGInstances,
            apps,
            selectedTreeNode
          }}
        />
      )
    })
  }, [apps, cspDropDownData, domainPostFix, license?.entitlements, loading, selectedTSGInstances, selectedTreeNode])
  return (
    <ADDONS className="tw-flex tw-flex-col tw-gap-3">
      {addons}
      {bundleAddons}
    </ADDONS>
  )
}

Addons.propTypes = {}
export default Addons
